export default __webpack_public_path__ + "static/media/yjjg.19876f12.jpg";